"use client"

import type React from "react"
import { PlusCircle } from "lucide-react"
import { Link } from "react-router-dom"

interface PlusButtonProps {
  // Content
  title?: string

  // Actions
  onClick?: () => void
  to?: string // For Link navigation

  // Custom styling
  className?: string
  style?: React.CSSProperties
}

export function PlusButton({ title, onClick, to, className = "", style }: PlusButtonProps) {
  const buttonContent = (
    <button
      className={`d-flex align-items-center justify-content-center ${className}`}
      style={{
        background: "white",
        border: "none",
        borderRadius: "16px",
        width: "64px",
        height: "64px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        cursor: "pointer",
        transition: "all 0.2s ease",
        ...style,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.05)"
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)"
      }}
      onClick={onClick}
      title={title}
    >
      <PlusCircle size={32} className="text-primary" fill="none" strokeWidth={3} />
    </button>
  )

  if (to) {
    return <Link to={to}>{buttonContent}</Link>
  }
  return buttonContent
}
